// extracted by css-extract-rspack-plugin
export default {"root":"root--JWOoJhvnwHATQRGH","year":"year--zeOGDDbIlz0WBnY2","hint":"hint--AYcK5GE_70gWjPgx"};